import { FilterType, IAccessoryFilter } from '../../interfaces';

import CheckboxField from '../../../../components/field/checkbox/CheckboxField'; // Assuming it exists
import { CollapseProps } from '../../../../components/collapsible/collapsible';
import { FieldType } from '../../../../components/field/Field';
import InputSliderField from '../../../../components/input-with-slider/inputWithSlider';
import RadioField from '../../../../components/field/radio/RadioField';
import './FilterFieldRenderer.scss';

interface FilterFieldRendererProps {
  filterType: FilterType;
  content?: IAccessoryFilter[];
  collapse: CollapseProps;
  props: any;
  selectedFacets?: IAccessoryFilter[];
  onSelect: (item: IAccessoryFilter, checked: boolean) => void;
}

export const FilterFieldRenderer: React.FC<FilterFieldRendererProps> = ({
  filterType,
  content,
  collapse,
  props,
  selectedFacets = [],
  onSelect,
}) => {
  if (filterType === FilterType.RADIO && content) {
    return (
      <div className="collapse-items">
        {content.map((item, index) => (
          <RadioField
            id={item.id}
            key={index}
            value={item.value}
            label={{
              label: item.label,
              fieldType: FieldType.RADIO,
              id: item.id.toString(),
            }}
            onChange={(e) => {
              const checked = e.target.checked;
              onSelect(item, checked);
            }}
            name={item.groupId}
            checked={selectedFacets.some((selected) => selected.id === item.id)}
            amount={item.countText !== undefined ? item.countText : undefined}
          />
        ))}
      </div>
    );
  } else if (filterType === FilterType.CHECKBOX && content) {
    return (
      <div className="collapse-items">
        {content.map((item, index) => (
          <CheckboxField
            id={item.id}
            key={index}
            label={`${item.label}`}
            checked={selectedFacets.some((selected) => selected.id === item.id)}
            onChange={(e) => {
              const checked = e.target.checked;
              onSelect(item, checked);
            }}
            value={item.value}
            amount={item.countText !== undefined ? item.countText : undefined}
          />
        ))}
      </div>
    );
  } else if (filterType === FilterType.SLIDER) {
    const sortedContent = [...(content ?? [])].sort(
      (a, b) => Number(a.key) - Number(b.key)
    );
    const firstItem = sortedContent[0];
    const lastItem = sortedContent[sortedContent.length - 1];

    return (
      <InputSliderField
        min={Number(firstItem.value)}
        max={Number(lastItem.value)}
        step={props.stepSize}
        value={
          selectedFacets.some(
            (selected) =>
              selected.id ===
              `${FilterType.SLIDER}-${props.attributeConfig.fieldName}`
          )
            ? Number(
                selectedFacets.find(
                  (selected) =>
                    selected.id ===
                    `${FilterType.SLIDER}-${props.attributeConfig.fieldName}`
                )?.value ?? 0
              )
            : Number(firstItem?.value ?? 0)
        }
        onChange={(value: number) => {
          const accessoryFilter: IAccessoryFilter = {
            id: `${FilterType.SLIDER}-${props.attributeConfig.fieldName}`,
            label: `${props.label}`,
            value: value.toString(),
            key: value.toString(),
            filterType: FilterType.SLIDER,
            groupId: props.attributeConfig.fieldName,
            includedInTopFilter: false,
          };
          onSelect(accessoryFilter, true);
        }}
        id={collapse.id !== undefined ? collapse.id.toString() : ''}
      />
    );
  }

  return null;
};
